import { render, staticRenderFns } from "./HNSelection.vue?vue&type=template&id=4c2d0513&scoped=true"
import script from "./HNSelection.vue?vue&type=script&lang=js"
export * from "./HNSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2d0513",
  null
  
)

export default component.exports